import { useSelector } from "react-redux";

const useAuth = () => {
  const authUser =  useSelector((state) => state.auth); 
  return authUser;
};

export default useAuth;
